import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AttachmentDto } from '@proxy/attachments';
import { AttachmentService } from '@proxy/common';
import { NzDrawerComponent, NzDrawerRef } from 'ng-zorro-antd/drawer';
import { LinkTarget, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { ChangeDetectorRef } from '@angular/core';
import { PdfViewerCoordinatorService } from '../pdf-viewer-coordinator.service';

@Component({
  selector: 'app-x-file-preview',
  templateUrl: './x-file-preview.component.html',
  styleUrls: ['./x-file-preview.component.scss'],
})
export class XFilePreviewComponent implements OnInit, OnDestroy {
  @ViewChild('nzTitle') nzTitle: TemplateRef<any>;

  @Input() item: AttachmentDto;
  // Optional: when a caller has more than one attachment for the same record (e.g. an invoice
  // with several uploads), pass the full list here to get a tab per file. Callers that only ever
  // pass `item` (the majority) are unaffected — no tabs render for a single file.
  @Input() items?: AttachmentDto[];

  // A unique DOM id per instance is good hygiene (this drawer can theoretically be opened more
  // than once at a time), but it does NOT prevent ngx-extended-pdf-viewer content collisions by
  // itself; see PdfViewerCoordinatorService (acquire/release below) for the actual fix.
  private static nextViewerId = 0;
  readonly viewerId = `x-file-preview-viewer-${XFilePreviewComponent.nextViewerId++}`;

  activeItem: AttachmentDto;
  previewPdfVisible = false;
  previewContent: any;
  filePrevSize: string;

  constructor(
    private attachmentService: AttachmentService,
    private nzDrawerRef: NzDrawerRef,
    private cdr: ChangeDetectorRef,
    private pdfViewerCoordinator: PdfViewerCoordinatorService,
  ) {
    pdfDefaultOptions.externalLinkTarget = LinkTarget.BLANK;
    pdfDefaultOptions.disableHistory = true;
  }

  ngOnInit(): void {
    // This component is only ever created (nzDrawerService.create) when its drawer is opened,
    // and destroyed when it closes — so acquire/release map exactly to that lifecycle.
    this.pdfViewerCoordinator.acquire();
    this.activeItem = this.item ?? this.items?.[0];

    setTimeout(() => {
      this.filePrevSize = localStorage.getItem('filePrevSize') || '50%';
      this.nzDrawerRef.nzWidth = this.filePrevSize;
      const nzDrawerComp = this.nzDrawerRef as NzDrawerComponent;
      nzDrawerComp.nzTitle = this.nzTitle;
      this.loadPreview(this.activeItem);
    });
  }

  ngOnDestroy(): void {
    this.pdfViewerCoordinator.release();
  }

  selectItem(selected: AttachmentDto): void {
    if (!selected || selected.id === this.activeItem?.id) return;
    this.activeItem = selected;
    this.loadPreview(selected);
  }

  private loadPreview(item: AttachmentDto): void {
    if (!item) return;
    this.previewPdfVisible = false;
    this.attachmentService.download(item.id, null).subscribe(s => {
      this.previewPdfVisible = true;
      this.previewContent = s.content;
      this.cdr.detectChanges();
    });
  }

  close(): void {
    this.nzDrawerRef.close();
  }

  windowResize() {
    this.filePrevSize = this.filePrevSize === '50%' ? '90%' : '50%';
    this.nzDrawerRef.nzWidth = this.filePrevSize;
    localStorage.setItem('filePrevSize', this.filePrevSize);
  }
}
